import type { Block } from '@/types/blocks'
import type { ContentLang } from '@/features/editor/editorSlice'
import { BlockThumbnail } from './BlockThumbnail'

const noop = () => {}

/**
 * Миниатюра удалённого блока на время анимации ухода: та же картинка, но
 * неживая (без событий указателя) — кликать по блоку, которого уже нет, нечего.
 */
export const LeavingThumbnail = ({
  block,
  index,
  contentLang,
}: {
  block: Block
  index: number
  contentLang: ContentLang
}) => (
  <div
    aria-hidden="true"
    className="pointer-events-none h-full shrink-0 animate-thumb-out overflow-x-clip"
  >
    <BlockThumbnail
      block={block}
      index={index}
      selected={false}
      onSelect={noop}
      onDelete={noop}
      onDuplicate={noop}
      duplicateDisabled
      onToggleSelect={noop}
      multiSelected={false}
      isCourseAuthor={false}
      contentLang={contentLang}
      inRun={false}
      lockReason="edit"
    />
  </div>
)
